import {
  jb_button_secondary_css_default
} from "./chunk.5AG74FXE.js";
import {
  ae
} from "./chunk.RIMVGMXQ.js";
import {
  Linkable
} from "./chunk.LK5OUX7S.js";
import {
  Rt
} from "./chunk.LQ2ZH6PS.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  Initiable
} from "./chunk.6DHNIVN5.js";
import {
  ButtonElement
} from "./chunk.WJFRXGBY.js";
import {
  D,
  ke,
  r
} from "./chunk.WKUNRGJV.js";
import {
  n
} from "./chunk.LWNTGWZJ.js";
import {
  __decorateClass
} from "./chunk.2QRLEY22.js";

// src/components/jb-button-secondary/jb-button-secondary.ts
var JbButtonSecondary = class extends Initiable(ButtonElement(Linkable(r))) {
  render() {
    const classes = { inactive: !!this.inactive, hover: !!this.forceHover, inverted: !!this.inverted };
    return this.link?.href ? ke`<a
          data-linkable
          class=${Rt(classes)}
        >
          <slot>${this.text ? ae(this.text) : D}</slot>
        </a>` : ke`<button
          ?disabled=${this.inactive}
          class=${Rt(classes)}
        >
          <slot>${this.text ? ae(this.text) : D}</slot>
        </button>`;
  }
};
JbButtonSecondary.styles = jb_button_secondary_css_default;
JbButtonSecondary.shadowRootOptions = { ...r.shadowRootOptions, delegatesFocus: true };
__decorateClass([
  n({ type: Boolean })
], JbButtonSecondary.prototype, "forceHover", 2);
__decorateClass([
  n({ type: Boolean })
], JbButtonSecondary.prototype, "inactive", 2);
__decorateClass([
  n({ type: Boolean })
], JbButtonSecondary.prototype, "inverted", 2);
__decorateClass([
  n({ type: Object })
], JbButtonSecondary.prototype, "link", 2);
__decorateClass([
  n()
], JbButtonSecondary.prototype, "name", 2);
__decorateClass([
  n()
], JbButtonSecondary.prototype, "text", 2);
JbButtonSecondary = __decorateClass([
  customElement("jb-button-secondary")
], JbButtonSecondary);

export {
  JbButtonSecondary
};
